import { useEffect, useState } from 'react';
import SelfAssessment from './SelfAssessment';
import axios from 'axios';
import GuideAsmt from '../LandingPage/GuideAsmt';
import FancyLoader from '../../hooks/FancyLoder';

const API_URL = process.env.REACT_APP_API_URL;

export const ParentComponent = ({ name }) => {
    const [data, setData] = useState({
        answers: [],
        plr: [],
        components: [],
        statements: [],
    });
    const [showSelfAsmt, setShowSelfAsmt] = useState(false); // Toggle state to show self-assessment

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responses = await Promise.all([
                    axios.get(`${API_URL}/answers`),
                    axios.get(`${API_URL}/plr`),
                    axios.get(`${API_URL}/components`),
                    axios.get(`${API_URL}/statements`),
                ]);

                setData({
                    answers: responses[0].data,
                    plr: responses[1].data,
                    components: responses[2].data,
                    statements: responses[3].data,
                });
            } catch (err) {
                console.error(err.message);
            }
        };

        fetchData();
    }, []);

    // Check if data is still loading
    if (!data.statements || !data.components || !data.answers || !data.plr) {
        return <div><FancyLoader/></div>;
    }

    if (!data.statements.length || !data.components.length || !data.answers.length || !data.plr.length) {
        return <div><FancyLoader/></div>;
    }

    const limitedStatements = data.statements.slice(0, 5);

    if (!showSelfAsmt) {
        return (
            <GuideAsmt name={name}
                onContinue={() => setShowSelfAsmt(true)} // Button click handler to show SelfAssessment
            />
        );
    }

    return (
        <SelfAssessment
            name={name}
            components={data.components}
            statements={data.statements}
            plr={data.plr}
            answers={data.answers}
        />
    );
};


export default ParentComponent;
